'use client';
import DemoPageClient from './DemoPageClient';

export default function DemoPage() {
  return <DemoPageClient />;
}
